// Import React and Hooks
import React, { useEffect } from 'react'

// Import Redux and Hooks
import { Dispatch } from "redux"
import { useAppSelector, useAppDispatch } from '../hooks/useRedux'
// Import Actions
import { downloadHomeDataAction } from '../actions/homeAction'
// Import Components
//import Background from '../components/layout/Background'
import LaunchBox from '../components/ui/LaunchBox'

import { useHistory } from 'react-router-dom'



const Home = () => {



  // Use Selector
  const homeData = useAppSelector( state => state.home )


  // Use History
  const history = useHistory()

  // Use Dispatch
  const dispatch:Dispatch<any> = useAppDispatch()



  // Use Effect
  useEffect( () => {
    dispatch( downloadHomeDataAction() )
    /*const params = new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop:string) => searchParams.get(prop),
    });*/
    const params = new URLSearchParams(window.location.search);
    if(params.get('uid') != null){
      history.push('/cempasuchil/crear-ofrenda')
    }
  }, [] )


  
  return (
    <div className="container container--home">
      <LaunchBox
        launchBoxData={ homeData } />
    </div>
    )
}



export default Home
